import React from "react";
import { Avatar, Text } from "@mantine/core";
import { MantineSize } from "@mantine/core";

export interface StaffAvatarProps {
  /** Full URL of the staff profile photo (from staff_photo_url). Falls back to initials when null/undefined. */
  photoUrl?: string | null;
  /** First name - used for fallback initial when no photo */
  firstName: string;
  /** Last name - used for fallback initial (takes precedence over first initial) */
  lastName?: string;
  /** Avatar size */
  size?: MantineSize | number;
  /** Avatar border radius */
  radius?: MantineSize | number;
  /** Color for the initials fallback (e.g. "teal", "teal", "gray") */
  color?: string;
  /** Mantine background style prop (e.g. a design token for a tinted avatar). */
  bg?: string;
  /** Mantine text-color style prop for the initials. */
  c?: string;
  /** Additional CSS (e.g. border) */
  style?: React.CSSProperties;
  /** Additional class name */
  className?: string;
}

/**
 * Reusable staff profile picture with fallback to initials.
 * Use staff_photo_url for display; when absent, shows last name initial.
 */
export default function StaffAvatar({
  photoUrl,
  firstName,
  lastName,
  size = "md",
  radius = "xl",
  color = "teal",
  bg,
  c,
  style,
  className,
}: StaffAvatarProps) {
  const fallbackInitial = `
  ${firstName?.charAt(0)?.toUpperCase()}${lastName?.charAt(0).toUpperCase()}`;

  return (
    <Avatar
      size={size}
      radius={radius}
      color={color}
      bg={bg}
      c={c}
      src={photoUrl || undefined}
      style={{ fontWeight: 500, ...style }}
      className={className}
    >
      <Text c="inherit" fw={500}>
        {fallbackInitial}
      </Text>
    </Avatar>
  );
}
